export default __webpack_public_path__ + "static/media/FAQMain.8e66fe26.jpg";